
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import RoundCard from '../components/league/roundCard.vue'
import {wxShareConfig} from '../js/common/utils'
import configInfo from "../configInfo.js"
export default {
props: {



},
data () {
return {
currentPage:null,
nodataTxt:"",
league:{},
leagueId:this.$route.query.leagueId,
eventHub:this.$store.getters.getEventHub,
leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
}
},
mounted(){





if (this.eventHub) {
this.eventHub.$on('loadMoreJifen', () => {
this.loadMore();
})
this.eventHub.$on('refreshTabJifen', () => {
this.refreshTab();
})
}
this.initTab();
},
components: {
Tab,
TabItem,
Scroller,
Divider,
XSwitch,
Group,
Spinner,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem,
RoundCard
},
beforeRouteLeave (to, from, next) {
if(this.currentPage){

}
next();
},
methods: {
initWxShareConfig:function(){
this.currentPage = window.location.href;
var fullPath = window.location.href;

var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
if (this.leagueBasicInfo.league_logo) {
shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
}
console.log(fullPath)

wxShareConfig({
title: this.leagueBasicInfo.title+'-积分分享',
desc: "来自未来足球赛事系统",
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {
console.log("share success")
}, () => {
console.log("share error")
});
},
initTab(){
this.eventHub.$emit("setTabIndex", "leagueTable");

this.initWxShareConfig();
var leagueId = parseInt(this.leagueId);
if ((!this.league.scoreBoard || this.league.scoreBoard.length < 1) && (!this.league.groups || this.league.groups.length < 1)) {
this.$vux.loading.show({
text: '加载中...'
})

this.loadData(leagueId, () => {
this.$vux.loading.hide()
})
}
},
loadData(leageID, afterCall){
this.nodataTxt = "";
this.hagkHttp(this.hagkApi.getLeagueTable(leageID), {})
.then((res) => {
if (res.status == true) {
this.league = res.result;
if(res.result && res.result.scoreBoard != null && res.result.scoreBoard.length == 0) {
this.nodataTxt = "暂无数据";
}
}
}, (error) => {
console.log(error);
});
afterCall();
},
refreshTab(){
var leagueId = parseInt(this.leagueId)
this.loadData(leagueId, () => {
this.eventHub.$emit("enablerefreshTab")
})
},
loadMore(){
this.eventHub.$emit("enableloadMore");
}
}
}



// WEBPACK FOOTER //
// ./src/views/leagueOngoingJifen.vue